import { createFileRoute } from '@tanstack/react-router';

import { ApplicatorProfileDetail } from '@/features/applicator-profiles/ApplicatorProfileDetail';

export const Route = createFileRoute('/_authenticated/applicator-profiles/$profileId')({
  component: ApplicatorProfileDetail,
});
